import React, { FC } from 'react';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { Image } from 'antd';
import { Text } from 'components/text/Text';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import tw from 'twin.macro';
import { HeadingPublishOffer } from 'src/pages-all/offer-form/components/common';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { PUBLISH_PROCESS_1, PUBLISH_PROCESS_2, PUBLISH_PROCESS_3 } from 'assets/icons/publish-process/publish-process';
import { GroupWrap } from 'components/group-wrap/group-wrap';

const GuideWrapper = styled.div``;

const Row = styled(GroupWrap)`
  overflow: hidden;
  display: flex;
  width: 100%;
  .group-wrap-item {
    flex: 1;
    display: flex;
    width: 100%;

    .ant-card {
      min-width: 200px;
      width: 100%;
    }
  }
`;

const StyledCard = styled.div`
  padding: 18px;
`;

const CardWrapper = styled(({ minWideDesktop, minDesktop, ...rest }) => <StyledCard {...rest} />)`
  width: ${({ minWideDesktop, minDesktop }: { minDesktop: boolean; minWideDesktop: boolean }) =>
  minWideDesktop ? '210px' : minDesktop ? '150px' : '100%'};
  max-width: ${({ minWideDesktop, minDesktop }: { minDesktop: boolean; minWideDesktop: boolean }) =>
  minWideDesktop ? '210px' : minDesktop ? '150px' : '100%'};
  border-radius: 0;
  border: 1px solid ${colors.border};
  padding: 18px;
`;

const ItemContainer = styled.div`
  ${tw`flex items-start justify-center`};
  padding-bottom: 8px;
  padding-top: 8px;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: ${({ height }: { height: string }) => height}px;
  img {
    width: auto;
  }
`;

const GuideTile: FC<{ imgSrc: string; heading: string; paragraph: string }> = ({
                                                                                 imgSrc,
                                                                                 heading,
                                                                                 paragraph,
                                                                               }) => {
  const { minWideDesktop, minDesktop } = useBreakpoints();

  return (
    <CardWrapper minDesktop={minDesktop} minWideDesktop={minWideDesktop}>
      <ImageWrapper height={minWideDesktop ? '140' : '120'}>
        <Image src={imgSrc} height={minWideDesktop ? 140 : 120} preview={false} />
      </ImageWrapper>
      <ItemContainer style={{ minHeight: minDesktop ? '80px' : undefined }}>
        <Text size={14} color="grey" strong>
          {heading}
        </Text>
      </ItemContainer>
      <ItemContainer>
        <Text size={14} color="grey">
          {paragraph}
        </Text>
      </ItemContainer>
    </CardWrapper>
  );
};

interface props {
  guideTilesList?: {
    imgSrc: string,
    heading: string,
    paragraph: string,
  }[],
  guideHeadline?: string,
}

export const Guide: FC<props> = ({ guideTilesList, guideHeadline }) => {
  const _guideTilesList = guideTilesList || [
    {
      imgSrc: PUBLISH_PROCESS_1,
      headline: translate(translationKeys.publishOffer.guide.example1.heading),
      paragraph: translate(translationKeys.publishOffer.guide.example1.paragraph),
    },
    {
      imgSrc: PUBLISH_PROCESS_2,
      headline: translate(translationKeys.publishOffer.guide.example2.heading),
      paragraph: translate(translationKeys.publishOffer.guide.example2.paragraph),
    },
    {
      imgSrc: PUBLISH_PROCESS_3,
      headline: translate(translationKeys.publishOffer.guide.example3.heading),
      paragraph: translate(translationKeys.publishOffer.guide.example3.paragraph),
    },
  ];
  return (
    <GuideWrapper>
      <HeadingPublishOffer level={2}>
        {
          guideHeadline ? guideHeadline :
          translate(translationKeys.publishOffer.guide.heading)
        }
      </HeadingPublishOffer>
      <div style={{ marginBottom: '20px', width: '100%' }}>
        <Row gap={1} alignItems="normal">
          {_guideTilesList.map((guideTile, i) =>
            (<GuideTile
              key={i}
              imgSrc={guideTile.imgSrc}
              heading={guideTile.heading}
              paragraph={guideTile.paragraph}
            />)
          )}
        </Row>
      </div>
    </GuideWrapper>
  );
};
